import React, {
    useState,
    useEffect,
    useRef,
    forwardRef,
    useImperativeHandle,
  } from "react";
  
  interface Tab {
    label: string;
    value: string;
  }
  
  interface SlidingTabsProps {
    tabs: Tab[];
    defaultActive?: string;
    onChange?: (value: string) => void;
  }
  
  export interface SlidingTabsRef {
    resetToFirstTab: () => void;
    setActiveTab: (value: string) => void;
  }
  
  const UnderlineSlidingTabs = forwardRef<SlidingTabsRef, SlidingTabsProps>(
    ({ tabs, defaultActive, onChange }, ref) => {
      const [active, setActive] = useState(defaultActive || tabs[0]?.value);
      const containerRef = useRef<HTMLDivElement>(null);
      const [sliderStyle, setSliderStyle] = useState({ width: 0, left: 0 });
  
      useEffect(() => {
        const activeEl = document.getElementById(`tab-${active}`);
        if (activeEl) {
          setSliderStyle({
            width: activeEl.offsetWidth,
            left: activeEl.offsetLeft,
          });
        }
      }, [active, tabs]);
  
      const handleClick = (value: string) => {
        setActive(value);
        onChange?.(value);
      };
  
      useImperativeHandle(ref, () => ({
        resetToFirstTab() {
          const first = defaultActive || tabs[0]?.value;
          if (first) {
            setActive(first);
            onChange?.(first);
          }
        },
        setActiveTab(value: string) {
          setActive(value);
          onChange?.(value);
        },
      }));
  
      return (
        <div className="mx-5 bg-[#FAFDFF]">
          <div
            ref={containerRef}
            className="relative flex gap-8 "
          >
            {/* Sliding underline */}
            <span
              className="absolute bottom-[-1px] h-[2.5px] bg-greenBg transition-all duration-300"
              style={{
                width: sliderStyle.width +1,
                left: sliderStyle.left,
              }}
            />
  
            {tabs.map((tab) => (
              <button
                key={tab.value}
                id={`tab-${tab.value}`}
                onClick={() => handleClick(tab.value)}
                className={`pb-3 pt-3 text-[13px] font-medium transition-colors
                  ${
                    active === tab.value
                      ? "text-greenBg"
                      : "text-gray-500 hover:text-greenBg"
                  }
                `}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      );
    }
  );
  
  export default UnderlineSlidingTabs;
  